declare global {
    interface Window {
        // Create function type (for Typescript's typechecker) on window object to assign recaptcha V2 handler
        onV2VerifiedNotARobot: (ResponseToken: string | null) => Promise<void>;
    }
}

export class MyRecaptchaHandler {
    private static ClientSidePassedRecaptchaTest = false;
    private static V3Action: string;

    public static async MyRecaptchaHandlerInit(V3Action: string, SiteKeyV2: string, SiteKeyV3: string) {
        MyRecaptchaHandler.V3Action = V3Action;

        await MyRecaptchaHandler.loadRecaptchaScript(SiteKeyV3).then(() => {
            grecaptcha.ready(async () => {
                // Check if reCaptcha V3 is available, otherwise setup V2
                const divGRecaptcha = document.getElementById('g-recaptchaV2') as HTMLDivElement;
                if (divGRecaptcha) {
                    let recaptchaV3Available = false;
                    // Test if recaptcha V3 is available
                    try { // If grecaptcha.execute() doesn't throw an exception, then assume V3 is available
                        // V3 tokens expire in two minutes, so don't bother saving it (https://developers.google.com/recaptcha/docs/v3)
                        await grecaptcha.execute(SiteKeyV3, { action: MyRecaptchaHandler.V3Action });
                        recaptchaV3Available = true;
                    }
                    catch { }

                    if (recaptchaV3Available) {
                        grecaptcha.render(divGRecaptcha, { 'sitekey': SiteKeyV3 });
                        MyRecaptchaHandler.ClientSidePassedRecaptchaTest = true;
                    }
                    else {
                        // V3 failed, so use V2
                        // Assign call-back function to run when reCaptcha V2 test has been passed by user
                        window.onV2VerifiedNotARobot = async (ResponseToken: string | null) => {
                            let V2TokenElem = (document.getElementById("reCaptchaV2Token") as HTMLInputElement);
                            if (V2TokenElem !== null)
                                V2TokenElem.value = ResponseToken ?? "";
                            V2TokenElem.dispatchEvent(new Event('change', { 'bubbles': true })); // Tell Blazor that value changed
                            MyRecaptchaHandler.ClientSidePassedRecaptchaTest = true;
                            (document.getElementById("g-recaptchaV2") as HTMLDivElement).style.display = "none";
                        }

                        grecaptcha.render(divGRecaptcha, { 'sitekey': SiteKeyV2 });
                        (document.getElementById("g-recaptchaV2") as HTMLDivElement).style.display = "revert";
                    }
                }
            });
        }).catch((reason) => {
            console.error(reason);
        })
    }

    // Dynamically load recaptcha script
    private static loadRecaptchaScript(SiteKeyV3: string) {
        return new Promise((resolve, reject) => {
            const script = (document.createElement('script') as HTMLScriptElement);
            script.src = `https://www.google.com/recaptcha/api.js?render=${SiteKeyV3}`; // Recaptcha SiteKey V3
            script.addEventListener("load", resolve);
            script.addEventListener("error", reject);
            document.body.appendChild(script);
        });
    }

    // Client-side validation only; still need to validate on server
    public static ClientSidePassedTest = () => MyRecaptchaHandler.ClientSidePassedRecaptchaTest;
}
